import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  ClearLink,
  Container,
  IconContainer,
  StyledEmptyListIcon,
  Subtitle,
  SubtitleContainer,
  Title,
} from './EmptyList.styles';

interface EmptyListProps {
  title?: string;
  subtitle?: string;
  searchText?: string;
  onClearSearch?: () => void;
}

const EmptyList = ({ title, subtitle, searchText, onClearSearch, ...rest }: EmptyListProps) => {
  const { t } = useTranslation();
  return (
    <Container {...rest}>
      <IconContainer>
        <StyledEmptyListIcon />
      </IconContainer>
      <Title>
        {searchText
          ? t('organization.members.emptyListTitle', { searchText, interpolation: { escapeValue: false } })
          : title || t('organization.members.emptyListTitleShort')}
      </Title>
      <SubtitleContainer>
        <Subtitle>
          {searchText ? (
            <Trans
              i18nKey="organization.members.emptyListSubtitle"
              components={{ clear: <ClearLink onClick={onClearSearch} /> }}
            />
          ) : (
            subtitle || t('organization.members.emptyListSubtitleShort')
          )}
        </Subtitle>
      </SubtitleContainer>
    </Container>
  );
};

export default EmptyList;
